import React from 'react'

import BaseConsultsList from 'ui/views/consults/BaseConsultsList'
import analysisStatusConstants from 'utils/constants/analysisStatus'
import { MANUAL_DERIVATION_STATUS } from 'utils/constants/manualDerivationStatus'

export default function ({ location }) {
  const title = 'Finalizadas - Reprovado'
  const subtitle = `Consultas reprovadas em analise manual`
  const color = '#E91010'
  const analysisStatus = analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.reproved
  const manualDerivationStatus = MANUAL_DERIVATION_STATUS.FINALIZED
  const withManualAnalysis = true
  const itemWithManualAnalysis = true

  return (
    <BaseConsultsList
      location={location}
      title={title}
      subtitle={subtitle}
      color={color}
      analysisStatus={analysisStatus}
      manualDerivationStatus={manualDerivationStatus}
      withManualAnalysis={withManualAnalysis}
      itemWithManualAnalysis={itemWithManualAnalysis}
    />
  )
}
